import React from "react";

function TestimonialSection() {
  return (
    <div className="testimonial-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 text-center">
            <div className="webinar-title-lg">Testimonials</div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12">
            <div className="testimonial-container">
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <div className="avatar">SV</div>
                  <div className="user-info">
                    <h3>SHASHIKANT VERMA</h3>
                    <p>JAI MATA DI TRADERS</p>
                  </div>
                  <div className="stars">★★★★☆</div>
                </div>

                <p className="testimonial-text">
                  "Since using Kiko Live, our orders have soared! The dashboard helps us
                  track performance and secure deals we might have missed before."
                </p>
              </div>
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <div className="avatar">SV</div>
                  <div className="user-info">
                    <h3>Soman Kumar Verma </h3>
                    <p>Kamal Narayan Kirana Store</p>
                  </div>
                  <div className="stars">★★★★☆</div>
                </div>

                <p className="testimonial-text">
                  "Kiko Live has transformed our business! The intuitive dashboard allows us to monitor our sales and seize opportunities we previously overlooked."
                </p>
              </div>
              <div className="testimonial-card">
                <div className="testimonial-header">
                  <div className="avatar">ST</div>
                  <div className="user-info">
                    <h3>SUNNY TANWANI</h3>
                    <p>SINDHI NAMKEEN & DRY FRUITS</p>
                  </div>
                  <div className="stars">★★★★☆</div>
                </div>

                <p className="testimonial-text">
                  "Since using Kiko Live, our orders have soared! The dashboard helps us track performance and secure deals we might have missed before."
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TestimonialSection; 